import { provideQuillConfig, QuillConfig, QuillToolbarConfig } from 'ngx-quill';
import { retry } from 'rxjs';
import { environment } from 'src/environments/environment';

import { isPlatformBrowser } from '@angular/common';
import {
  HttpHandlerFn, HttpInterceptorFn, HttpRequest, provideHttpClient, withFetch, withInterceptors
} from '@angular/common/http';
import {
  ApplicationConfig, inject, isDevMode, PLATFORM_ID, provideAppInitializer,
  provideZonelessChangeDetection
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  InMemoryScrollingOptions, NoPreloading, provideRouter, RouterConfigOptions, withInMemoryScrolling,
  withPreloading, withRouterConfig, withViewTransitions
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
// firebase.config.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

import { routes } from './app.routes';
export const app = initializeApp(environment.firebaseConfig);

export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

/**
 * Analytics is loaded lazily after bootstrap. Initializing it during module
 * evaluation broke the production bundle: the bundler hoisted this module
 * above the @firebase/installations registration that getAnalytics needs,
 * throwing "Service installations-internal is not available".
 */
function initAnalytics(): void {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return;
  }

  import('firebase/analytics').then(async ({ getAnalytics, isSupported }) => {
    if (await isSupported()) {
      getAnalytics(app);
    }
  });
}

const quillToolbar: QuillToolbarConfig =
  [['bold'], ['link'], [{ color: [] }], [{ align: [] }]];

const quillConfig: QuillConfig = {
  modules: { syntax: false, toolbar: { container: quillToolbar } }
};

const retryInterceptor = (retryTimes: number): HttpInterceptorFn => {
  return (request: HttpRequest<any>, next: HttpHandlerFn) => {
    const cloneRequest = request.clone();

    return next(cloneRequest).pipe(retry(retryTimes));
  };
};

const routerConfig: RouterConfigOptions =
  { onSameUrlNavigation: 'reload' };

const routerScrolling: InMemoryScrollingOptions =
  { scrollPositionRestoration: 'enabled' };

const workerName = 'ngsw-worker.js';

const workerConfig = {
  registrationStrategy: 'registerWhenStable:30000',
  enabled: !isDevMode(),
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideAppInitializer(initAnalytics),
    provideHttpClient(
      withFetch(),
      withInterceptors([retryInterceptor(2)])
    ),
    provideServiceWorker(workerName, workerConfig),
    provideAnimations(),
    provideQuillConfig(quillConfig),

    provideRouter(routes,
      withPreloading(NoPreloading),
      withRouterConfig(routerConfig),
      withInMemoryScrolling(routerScrolling),
      withViewTransitions(),
    ),

  ],
};
